<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="front">BEHIND THE SMILE</p>
<p class="img"><img alt="images" src="images/14_2.jpg" style="height: auto; width: auto; margin:0px 0px 0px 0px; padding:0px 0px 0px 0px; border:0px;"/></p>
<p class="fig-caption">The Caribbean.</p>
<p class="img"><img alt="images" src="images/15_1.jpg" style="height: auto; width: auto; margin:0px 0px 0px 0px; padding:0px 0px 0px 0px; border:0px;"/></p>
<p class="fig-caption">Barbados with parish boundaries identified.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front1.vue?63be8fe0